import React from 'react';

interface Props {
  className?: string;
  width?: number;
  height?: number;
  color?: string;
}

export const ArrowLeft = ({
  className,
  width = 24,
  height = 24,
  color = 'currentColor',
}: Props) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.29279 11.3037L9.58578 7.01069C9.97816 6.63172 10.6019 6.63714 10.9876 7.02287C11.3733 7.40861 11.3788 8.03231 10.9998 8.42469L8.41378 11.0107H17.9998C18.5521 11.0107 18.9998 11.4584 18.9998 12.0107C18.9998 12.563 18.5521 13.0107 17.9998 13.0107H8.41378L10.9998 15.5967C11.3788 15.9891 11.3733 16.6128 10.9876 16.9985C10.6019 17.3842 9.97816 17.3897 9.58578 17.0107L5.29278 12.7177C4.9024 12.3272 4.90241 11.6942 5.29279 11.3037Z"
      fill={color}
    />
  </svg>
);
